import { Navigate, Route } from "react-router-dom";
import { List, Create } from "../components";

const contractTemplateRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"contract-template:index"} />,
    <Route path="list" element={<List />} key={"contract-template:list"} />,
    <Route path="new" element={<Create />} key={"contract-template:create"} />,
];

export default contractTemplateRoutes;
